exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/ingvars/BNC-Lab/front/src/app/static-contact/static-contact.component.css
// module id = ../../../../../src/app/static-contact/static-contact.component.css
// module chunks = 0